import { Space } from 'antd'
import CIMSButton from 'components/CIMSButton'
import { useState } from 'react'
import {
  Response,
  useRFITrackerContext,
} from '../../../../../../../RFITrackerContext'
import {
  useRestoreRfiResponseMutation,
  useSoftRemoveRfiResponseMutation,
} from 'schema'
import {
  simpleRemoveNotification,
  simpleRestoreNotification,
} from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'

type ResponseDevButtonsProps = Pick<
  Response,
  'id' | 'text' | 'closed' | 'deleted'
>

const ResponseDevButtons: React.VFC<ResponseDevButtonsProps> = ({
  id,
  text,
  closed,
  deleted,
}) => {
  const {
    refetch,
    editResponseModal: { toggle },
  } = useRFITrackerContext()
  const [remove] = useSoftRemoveRfiResponseMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveRFIResponse: {
        response: {
          user: { mail, displayName },
        },
      },
    }) => simpleRemoveNotification(`Response by ${displayName ?? mail}`),
  })
  const [restore] = useRestoreRfiResponseMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreRFIResponse: {
        response: {
          user: { mail, displayName },
        },
      },
    }) => simpleRestoreNotification(`Response by ${displayName ?? mail}`),
  })
  const [loading, setLoading] = useState(false)
  return (
    <Space
      style={{ width: '100%', marginBottom: '3px' }}
      size={0}
      direction="horizontal"
    >
      <CIMSButton
        style={{
          padding: '0px 10px 0px 0px',
        }}
        type="link"
        disabled={[
          {
            disabled: loading,
            reason: 'loading',
          },
          {
            disabled: closed,
            reason: {
              why: 'disabled',
              message: 'Cannot edit closing Responses',
            },
          },
        ]}
        onClick={() => toggle({ id, text })}
      >
        Edit
      </CIMSButton>
      {deleted ? (
        <CIMSButton
          style={{
            padding: 0,
          }}
          type="link"
          disabled={{
            disabled: loading,
            reason: 'loading',
          }}
          onClick={async () => {
            setLoading(true)
            await restore({
              variables: {
                id,
              },
            })
            refetch()
            setLoading(false)
          }}
        >
          Restore
        </CIMSButton>
      ) : (
        <CIMSButton
          style={{
            padding: 0,
          }}
          type="link"
          disabled={[
            {
              disabled: loading,
              reason: 'loading',
            },
            {
              disabled: closed,
              reason: {
                why: 'disabled',
                message: 'Cannot remove closing Responses',
              },
            },
          ]}
          onClick={async () => {
            setLoading(true)
            await remove({
              variables: {
                id,
              },
            })
            refetch()
            setLoading(false)
          }}
        >
          Remove
        </CIMSButton>
      )}
    </Space>
  )
}

export default ResponseDevButtons
